import React, { useState, useEffect, useRef } from 'react';
import {Eye,MoreVertical} from 'lucide-react';
import { doc, getDoc, setDoc, serverTimestamp, addDoc,collection } from 'firebase/firestore';
import { db } from "../../../config/firebase"; // Update with your actual firebase config path
import { getCookie, setCookie } from '../../../utils/local_storing';

function ProductsDisplay({ selectedProducts, selectionDisable, isLoading, setIsLoading, subMenu }) {
  const [options, setOptions] = useState([]);
  const [expandedCard, setExpandedCard] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const scrollContainerRef = useRef(null);
  const cardWidth = 200 + 12; // Increased card width for better image quality
  const [visibleCards, setVisibleCards] = useState(1);
  const [shopifyContext, setShopifyContext] = useState(null);
  const [cartStatus, setCartStatus] = useState({ loading: false, message: '' });

  // Time formatting functions (same as ChatFooter)
  const getCurrentTimeString = () => {
    const currentTime = new Date();
    let hours = currentTime.getHours();
    const minutes = currentTime.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;
    const formattedHours = String(hours).padStart(2, "0");
    const formattedMinutes = String(minutes).padStart(2, "0");
    return `${formattedHours}:${formattedMinutes} ${ampm}`;
  };

  useEffect(() => {
    // Get context from URL params
    const urlParams = new URLSearchParams(window.location.search);
    const encodedContext = urlParams.get('context');
    
    if (encodedContext) {
      try {
        const context = JSON.parse(atob(encodedContext));
        setShopifyContext(context);
        //console.log('Shopify Context:', context);
      } catch (error) {
        //console.error('Error parsing Shopify context:', error);
      }
    }
    
    // Request context from parent via PostMessage as backup
    window.parent.postMessage({
      type: 'REQUEST_SHOPIFY_CONTEXT'
    }, '*');
    
    // Listen for messages from parent window
    const handleMessage = (event) => {
      if (event.data.type === 'SHOPIFY_CONTEXT_RESPONSE') {
        setShopifyContext(event.data.data);
      }
      
      if (event.data.type === 'CART_UPDATED') {
        setCartStatus({
          loading: false,
          message: event.data.message,
          success: event.data.success
        });
        
        // Clear message after 3 seconds
        setTimeout(() => {
          setCartStatus({ loading: false, message: '' });
        }, 3000);
      }
      
      if (event.data.type === 'CURRENT_CART_RESPONSE') {
        //console.log('Current cart:', event.data.cart);
      }
    };
    
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  // Save action to Firestore (similar to ChatFooter handlechange)
  const saveActionToFirestore = async (actionText, productName) => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const currentDomain = urlParams.get("parentUrl");
      const channel = urlParams.get("channel") || "Web";
      const shopId = currentDomain || "null";
      
      const uidvar = currentDomain + "uid";
      let uid = getCookie(uidvar) || "";
      
      const currentTimeString = getCurrentTimeString();
      const currentTime = new Date();
      const seconds = currentTime.getSeconds();
      const month = String(currentTime.getMonth() + 1).padStart(2, "0");
      const day = String(currentTime.getDate()).padStart(2, "0");
      const year = currentTime.getFullYear();
      const formattedHours = String(currentTime.getHours() % 12 || 12).padStart(2, "0");
      const formattedMinutes = String(currentTime.getMinutes()).padStart(2, "0");
      const date_string = `${month}/${day}/${year}, ${formattedHours}:${formattedMinutes}:${seconds}`;
      
      const data_var = currentDomain + "myData";
      const storedData = getCookie(data_var);
      let docid = "";

      if (!storedData) {
        const initialData = { key: uid + Date.now().toString() };
        setCookie(data_var, JSON.stringify(initialData));
        docid = initialData.key;
      } else {
        const parsedData = JSON.parse(storedData);
        docid = parsedData.key;
      }

      // Note: Not updating UI, only saving to Firestore

      // Save to Firestore
      const docRef = doc(db, "Messages", docid);
      const docSnap = await getDoc(docRef);
      let assigned_to = "bot@krunk.ai";

      if (docSnap.exists()) {
        const message = docSnap.data().Messages;
        assigned_to = docSnap.data().assigned_to;
        message.push({ 
          user: `${actionText} - ${productName}`, 
          user_timestamp: date_string, 
          time: currentTimeString 
        });
        
        await setDoc(docRef, {
          Messages: message,
          server: false,
          user_id: docid,
          shop_id: shopId,
          User_Channel: "Web",
          timestamp: Date.now(),
          last_updated: serverTimestamp(),
        }, { merge: true });
      } 

      // Update message count

      // Trigger server call if needed (same logic as ChatFooter)
      if (assigned_to === "bot@krunk.ai") {
        setIsLoading(true); 
        let url = "";
        if (shopId === "null") {
           url='https://yaan-man.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid='+docid+"&shop_id="+"YaanMan";
          // url = 'http://127.0.0.1:8080/server?docid=' + docid + "&shop_id=" + "Krunk.ai";
          // url='https://justwravles-demo.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid='+docid+"&shop_id="+"JustWravels";
 
        } else if (shopId === "Krunk.ai") {
          url = "https://krunk-demo.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid=" + docid + "&shop_id=" + "Krunk.ai";
        } else if (shopId === "HomesterOnboardingProperties") {
          url = 'https://homesteronboarding.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid=' + docid + "&shop_id=" + "Krunk.ai";
        } else if (shopId === "JustWravels") {
          url='https://modular-bot.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid='+ docid+ "&shop_id=" +shopId + "&user_message="+`${actionText} - ${productName} `;
  
          // url = 'https://justwravles-demo.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid=' + docid + "&shop_id=" + "JustWravels";
        } 
             else if(shopId == "headsupfortails.myshopify.com"){
        url="https://heads-up-for-tails-bot.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid="+ docid + "&shop_id=" + "headsupfortails.myshopify.com" + "&user_message="+`${actionText} ${productName}`;
  
      }
        else{
            // url='https://shopify-agent.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid='+docid+"&shop_id="+shopId;
      url='https://modular-bot.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid='+ docid+ "&shop_id=" +shopId + "&user_message="+`${actionText} ${productName}`;
  
        }

        if (url) {
          fetch(url, { method: 'GET' })
            .then(() => {
              setIsLoading(false); 
            })
            .catch((err) => console.log("Error:", err));
        }
      }

    } catch (error) {
      //console.error("Error saving action to Firestore:", error);
    }
  };

  const saveAddtoCartInfo = async (actionText, productName, price) => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const currentDomain = urlParams.get("parentUrl");
      const channel = urlParams.get("channel") || "Web";
      const shopId = currentDomain || "null";
      
      const uidvar = currentDomain + "uid";
      let uid = getCookie(uidvar) || "";
      
      const currentTimeString = getCurrentTimeString();
      const currentTime = new Date();
      const seconds = currentTime.getSeconds();
      const month = String(currentTime.getMonth() + 1).padStart(2, "0");
      const day = String(currentTime.getDate()).padStart(2, "0");
      const year = currentTime.getFullYear();
      const formattedHours = String(currentTime.getHours() % 12 || 12).padStart(2, "0");
      const formattedMinutes = String(currentTime.getMinutes()).padStart(2, "0");
      const date_string = `${month}/${day}/${year}, ${formattedHours}:${formattedMinutes}:${seconds}`;
      
      const data_var = currentDomain + "myData";
      const storedData = getCookie(data_var);
      let docid = "";

      if (!storedData) {
        const initialData = { key: uid + Date.now().toString() };
        setCookie(data_var, JSON.stringify(initialData));
        docid = initialData.key;
      } else {
        const parsedData = JSON.parse(storedData);
        docid = parsedData.key;
      }

      // Note: Not updating UI, only saving to Firestore

      // Save to Firestore
      const docRef = doc(db, "Messages", docid);
      const docSnap = await getDoc(docRef);
      let assigned_to = "bot@krunk.ai";

      if (docSnap.exists()) {
        const message = docSnap.data().Messages;
        assigned_to = docSnap.data().assigned_to;
        message.push({ 
          user: `${actionText} ${productName}`, 
          user_timestamp: date_string, 
          time: currentTimeString 
        });
        
        await setDoc(docRef, {
          Messages: message,
          server: false,
          user_id: docid,
          shop_id: shopId,
          User_Channel: "Web",
          timestamp: Date.now(),
          last_updated: serverTimestamp(),
        }, { merge: true });
      } 

      const log_data={
        "event":"Add_to_cart",
        "params":{"item_name":productName, "price":price},
        "shop_id":shopId,
        "date": serverTimestamp()
      }
      await addDoc(collection(db, "Events"), log_data);

    } catch (error) {
      //console.error("Error saving action to Firestore:", error);
    }
  };

  useEffect(() => {
    const updateVisibleCards = () => {
      if (scrollContainerRef.current) {
        const containerWidth = scrollContainerRef.current.offsetWidth;
        const cardsPerView = Math.floor(containerWidth / cardWidth);
        setVisibleCards(Math.max(1, cardsPerView));
      }
    };

    updateVisibleCards();
    window.addEventListener('resize', updateVisibleCards);
    return () => window.removeEventListener('resize', updateVisibleCards);
  }, []);

  const handleScroll = () => {
    if (scrollContainerRef.current) {
      const scrollLeft = scrollContainerRef.current.scrollLeft;
      const newIndex = Math.round(scrollLeft / cardWidth);
      setCurrentIndex(newIndex);
    }
  };

  const scrollToIndex = (index) => {
    if (scrollContainerRef.current) {
      const scrollLeft = index * cardWidth;
      scrollContainerRef.current.scrollTo({
        left: scrollLeft,
        behavior: 'smooth'
      });
      setCurrentIndex(index);
    }
  };

  const totalPages = Math.ceil((options?.length || 0) / visibleCards);
  const currentPage = Math.floor(currentIndex / visibleCards);
  
  useEffect(() => {
    if (selectedProducts && selectedProducts.length !== 0) {
      setOptions(selectedProducts);
    }
  }, [selectedProducts]);

  const handleProductClick = (option, event) => {
    if (option.Website_Link) {
      let url = option.Website_Link;
      if (!url.startsWith('http://') && !url.startsWith('https://')) {
        url = 'https://' + url;
      }
      //console.log('Opening URL:', url);
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  const handleAddToCart = async (option, event) => {
    event.stopPropagation();
    
    try {
      // Set loading state
      setCartStatus({ loading: true, message: 'Adding to cart...' });
      
      const urlParams = new URLSearchParams(window.location.search);
      const currentDomain = urlParams.get("parentUrl");
      
      // Use PostMessage to add to parent Shopify cart
      const variantId = option.variant_id;
      
      if (!variantId) {
        throw new Error('Product variant ID not found');
      }
      
      // Send message to parent window to add to cart
      window.parent.postMessage({
        type: 'ADD_TO_CART',
        variantId: variantId,
        quantity: 1,
        properties: {
          '_chatbot_added': 'true',
          '_product_name': option.Name || '',
          '_added_via': 'chatbot',
          'source':'Krunk.ai'
        }
      }, '*');

      const price= option.Sell_Price
      await saveAddtoCartInfo("Add to cart", option.Name, price)
      
    } catch (error) {
      //console.error('Error adding to cart:', error);
      setCartStatus({
        loading: false,
        message: 'Failed to add to cart: ' + error.message,
        success: false
      });
      
      // Clear error message after 5 seconds
      setTimeout(() => {
        setCartStatus({ loading: false, message: '' });
      }, 5000);
    }
  };

  const [openMenuIndex, setOpenMenuIndex] = useState(null);

  const toggleMenu = (index, event) => {
    event.stopPropagation();
    
    // Don't open menu if loading
    if (isLoading) {
      return;
    }
    
    setOpenMenuIndex(openMenuIndex === index ? null : index);
  };

  // Close menu when clicking outside OR when loading starts
  useEffect(() => {
    const handleClickOutside = () => setOpenMenuIndex(null);
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  // Close menu when loading starts
  useEffect(() => {
    if (isLoading) {
      setOpenMenuIndex(null);
    }
  }, [isLoading]);

  const handleActionClick = async (menuItem, option, event) => {
    event.stopPropagation();
    
    // Don't allow action if loading
    if (isLoading) {
      return;
    }
    
    try {
      // Use the menu item text as the action text
      const actionText = menuItem;
      
      await saveActionToFirestore(actionText, option.Name || "Unknown Product");
    } catch (error) {
      //console.error(`Error handling action:`, error);
    } finally {
      // Close the expanded actions after clicking
      setExpandedCard(null);
    }
  };

  const [visibleProductCount, setVisibleProductCount] = useState(10);

  const loadMoreProducts = () => {
    setVisibleProductCount(prev => Math.min(prev + 10, options.length));
  };

  const productsToShow = options ? options.slice(0, visibleProductCount) : [];
  const hasMoreProducts = options && visibleProductCount < options.length;

  const ViewMoreCard = () => (
    <div
      className="krunk-bg-gradient-to-br krunk-from-blue-500 krunk-to-blue-600 krunk-flex krunk-items-center krunk-cursor-pointer krunk-justify-center krunk-rounded-xl krunk-self-start krunk-shadow-lg krunk-flex-shrink-0 krunk-transition-all krunk-duration-300 hover:krunk-shadow-xl"
      style={{
        width: '200px', // Match card width
        marginBottom: '8px',
        minHeight: '300px' // Adjusted to match new card height
      }}
      onClick={loadMoreProducts}
    >
      <div className="krunk-text-center krunk-text-white krunk-p-4">
        <div className="krunk-bg-white krunk-bg-opacity-20 krunk-rounded-full krunk-w-12 krunk-h-12 krunk-flex krunk-items-center krunk-justify-center krunk-mx-auto krunk-mb-3 krunk-transition-transform krunk-duration-300 hover:krunk-scale-110">
          <Eye size={24} className="krunk-text-white" />
        </div>
        <h3 className="krunk-text-lg krunk-font-semibold krunk-mb-2">View More</h3>
        <p className="krunk-text-blue-100 krunk-mb-3 krunk-text-sm">
          Discover {Math.min(10, options.length - visibleProductCount)} more products
        </p>
        <div className="krunk-bg-white krunk-bg-opacity-20 hover:krunk-bg-opacity-30 krunk-text-white krunk-px-4 krunk-py-2 krunk-rounded-full krunk-transition-all krunk-duration-200 krunk-inline-block krunk-text-sm">
          Load More
        </div>
      </div>
    </div>
  );

  return (
    <div className="krunk-mt-4">
      <div 
        ref={scrollContainerRef}
        className="krunk-overflow-x-scroll krunk-overflow-y-visible krunk-no-scrollbar krunk-flex krunk-items-center krunk-gap-3 krunk-h-full"
        onScroll={handleScroll}
      >
        {productsToShow && productsToShow.length !== 0 && productsToShow.map((option, i) => {
          return (
            <div
              key={i}
              className="krunk-bg-white krunk-flex krunk-items-center krunk-cursor-pointer krunk-justify-between krunk-flex-wrap krunk-rounded-xl krunk-self-start krunk-shadow-lg krunk-flex-shrink-0"
              style={{
                width: '200px', // Fixed width instead of min/max
                marginBottom: '8px' // space for shadow
              }}
              onClick={(event) => handleProductClick(option, event)}
            >
              <div className="krunk-w-full krunk-flex krunk-flex-col krunk-items-start krunk-self-start">
                
                <div className="krunk-w-full krunk-h-[240px] krunk-rounded-t-xl krunk-overflow-hidden">
                  <img
                    src={option?.['Image']}
                    className="krunk-w-full krunk-h-full krunk-object-cover krunk-transition-transform krunk-duration-200 hover:krunk-scale-110"
                    alt={option.Name || "Product image"}
                  />
                </div>
                
                <div className="krunk-text-xs krunk-px-2 krunk-w-full krunk-space-y-1 krunk-py-2">
                  <h3 className="krunk-capitalize krunk-text-sm krunk-line-clamp-1 krunk-font-semibold krunk-h-4 krunk-flex krunk-items-start">
                    {option.Name}
                  </h3>

                  <div>{option.Description}</div>
                  
                  <div className="krunk-flex krunk-items-center krunk-gap-1">
                    <span className="krunk-font-semibold">₹ {option.Sell_Price}</span>

                    {option.MRP && (
                      <>
                        <span className="krunk-line-through krunk-font-semibold krunk-text-gray-400">
                          ₹ {option.MRP}
                        </span>
                        <span
                          className=" krunk-text-green-700 krunk-text-[0.65rem] krunk-font-semibold krunk-px-1 krunk-py-[1px] krunk-rounded"
                        >
                          {Math.round(((option.MRP - option.Sell_Price) / option.MRP) * 100)}% OFF
                        </span>
                      </>
                    )}
                  </div>

                  {/* Action icons row */}
                  <div className="krunk-flex krunk-gap-2 krunk-mt-2">
                    {/* Add to cart button - always enabled */}
                    <button 
                      className="krunk-bg-buttonbackground krunk-text-white krunk-p-2 krunk-rounded-lg krunk-transition-colors krunk-flex krunk-items-center krunk-justify-center krunk-flex-1"
                      onClick={(event) => handleAddToCart(option, event)}
                    >
                      Add to cart
                    </button>

                    {/* Three dots menu - only show if subMenu exists and has items */}
                    {subMenu && subMenu.length > 0 && (
                      <div className="krunk-relative">
                        <button
                          className={`krunk-p-2 krunk-rounded-lg krunk-flex krunk-items-center krunk-justify-center krunk-transition-all ${
                            isLoading 
                              ? 'krunk-bg-gray-100 krunk-cursor-not-allowed' 
                              : 'hover:krunk-bg-gray-200'
                          }`}
                          onClick={(e) => toggleMenu(i, e)}
                          disabled={isLoading}
                        >
                          <MoreVertical 
                            size={16} 
                            className={`krunk-transition-colors ${
                              isLoading ? 'krunk-text-gray-300' : 'krunk-text-gray-600'
                            }`} 
                          />
                        </button>

                        {/* Drop-up menu - only show if not loading */}
                        {openMenuIndex === i && !isLoading && (
                          <div className="krunk-absolute krunk-bottom-full krunk-mb-2 krunk-right-0 krunk-bg-white krunk-shadow-lg krunk-rounded-lg krunk-overflow-hidden krunk-min-w-[150px] krunk-border krunk-border-gray-200">
                            {subMenu.map((menuItem, menuIndex) => (
                              <button
                                key={menuIndex}
                                className={`krunk-w-full krunk-text-left krunk-px-4 krunk-py-2 krunk-transition-colors ${
                                  menuIndex !== subMenu.length - 1 ? 'krunk-border-b krunk-border-gray-200' : ''
                                } ${
                                  isLoading 
                                    ? 'krunk-text-gray-400 krunk-cursor-not-allowed krunk-bg-gray-50' 
                                    : 'hover:krunk-bg-buttonbackground hover:krunk-text-white'
                                }`}
                                onClick={(event) => handleActionClick(menuItem, option, event)}
                                disabled={isLoading}
                              >
                                {menuItem}
                              </button>
                            ))}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
        {hasMoreProducts && <ViewMoreCard />}
      </div>
      
      {(() => {
        // Don't show dots if no products or all products fit in one view
        if (!options || options.length <= visibleCards) {
          return null;
        }
        
        // Calculate dots based on ACTUAL products that are currently shown
        const actualProductsShown = Math.min(visibleProductCount, options.length);
        const totalItemsShown = hasMoreProducts ? actualProductsShown + 1 : actualProductsShown; // +1 for view more card
        const totalDotsNeeded = Math.ceil(totalItemsShown / visibleCards);
        
        return (
          <div className="krunk-flex krunk-justify-center krunk-items-center krunk-mt-4 krunk-gap-2 krunk-mb-4">
            {Array.from({ length: totalDotsNeeded }, (_, index) => (
              <button
                key={index}
                onClick={() => scrollToIndex(index * visibleCards)}
                className={`krunk-w-2 krunk-h-2 krunk-rounded-full krunk-transition-all krunk-duration-200 ${
                  currentPage === index 
                    ? 'krunk-bg-buttonbackground krunk-w-6' 
                    : 'krunk-bg-gray-300 hover:krunk-bg-gray-400'
                }`}
                aria-label={`Go to page ${index + 1}`}
              />
            ))}
          </div>
        );
      })()}
    </div>
  );
}

export default ProductsDisplay;







// function ProductsDisplay({ selectedProducts, selectionDisable, isLoading, setIsLoading, subMenu }) {
//   const [options, setOptions] = useState([]);
//   const [expandedCard, setExpandedCard] = useState(null);
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const scrollContainerRef = useRef(null);
//   const cardWidth = 200 + 12;
//   const [visibleCards, setVisibleCards] = useState(1);
//   const [shopifyContext, setShopifyContext] = useState(null);
//   const [cartStatus, setCartStatus] = useState({ loading: false, message: '' });

//   // Time formatting functions (same as ChatFooter)
//   const getCurrentTimeString = () => {
//     const currentTime = new Date();
//     let hours = currentTime.getHours();
//     const minutes = currentTime.getMinutes();
//     const ampm = hours >= 12 ? "PM" : "AM";
//     hours = hours % 12;
//     hours = hours ? hours : 12;
//     const formattedHours = String(hours).padStart(2, "0");
//     const formattedMinutes = String(minutes).padStart(2, "0");
//     return `${formattedHours}:${formattedMinutes} ${ampm}`;
//   };

//   useEffect(() => {
//     // Get context from URL params
//     const urlParams = new URLSearchParams(window.location.search);
//     const encodedContext = urlParams.get('context');
    
//     if (encodedContext) {
//       try {
//         const context = JSON.parse(atob(encodedContext));
//         setShopifyContext(context);
//         //console.log('Shopify Context:', context);
//       } catch (error) {
//         //console.error('Error parsing Shopify context:', error);
//       }
//     }
    
//     // Request context from parent via PostMessage as backup
//     window.parent.postMessage({
//       type: 'REQUEST_SHOPIFY_CONTEXT'
//     }, '*');
    
//     // Listen for messages from parent window
//     const handleMessage = (event) => {
//       if (event.data.type === 'SHOPIFY_CONTEXT_RESPONSE') {
//         setShopifyContext(event.data.data);
//       }
      
//       if (event.data.type === 'CART_UPDATED') {
//         setCartStatus({
//           loading: false,
//           message: event.data.message,
//           success: event.data.success
//         });
        
//         // Clear message after 3 seconds
//         setTimeout(() => {
//           setCartStatus({ loading: false, message: '' });
//         }, 3000);
//       }
      
//       if (event.data.type === 'CURRENT_CART_RESPONSE') {
//         //console.log('Current cart:', event.data.cart);
//       }
//     };
    
//     window.addEventListener('message', handleMessage);
//     return () => window.removeEventListener('message', handleMessage);
//   }, []);

//   // Save action to Firestore (similar to ChatFooter handlechange)
//   const saveActionToFirestore = async (actionText, productName) => {
//     try {
//       const urlParams = new URLSearchParams(window.location.search);
//       const currentDomain = urlParams.get("parentUrl");
//       const channel = urlParams.get("channel") || "Web";
//       const shopId = currentDomain || "null";
      
//       const uidvar = currentDomain + "uid";
//       let uid = getCookie(uidvar) || "";
      
//       const currentTimeString = getCurrentTimeString();
//       const currentTime = new Date();
//       const seconds = currentTime.getSeconds();
//       const month = String(currentTime.getMonth() + 1).padStart(2, "0");
//       const day = String(currentTime.getDate()).padStart(2, "0");
//       const year = currentTime.getFullYear();
//       const formattedHours = String(currentTime.getHours() % 12 || 12).padStart(2, "0");
//       const formattedMinutes = String(currentTime.getMinutes()).padStart(2, "0");
//       const date_string = `${month}/${day}/${year}, ${formattedHours}:${formattedMinutes}:${seconds}`;
      
//       const data_var = currentDomain + "myData";
//       const storedData = getCookie(data_var);
//       let docid = "";

//       if (!storedData) {
//         const initialData = { key: uid + Date.now().toString() };
//         setCookie(data_var, JSON.stringify(initialData));
//         docid = initialData.key;
//       } else {
//         const parsedData = JSON.parse(storedData);
//         docid = parsedData.key;
//       }

//       // Note: Not updating UI, only saving to Firestore

//       // Save to Firestore
//       const docRef = doc(db, "Messages", docid);
//       const docSnap = await getDoc(docRef);
//       let assigned_to = "bot@krunk.ai";

//       if (docSnap.exists()) {
//         const message = docSnap.data().Messages;
//         assigned_to = docSnap.data().assigned_to;
//         message.push({ 
//           user: `${actionText} - ${productName}`, 
//           user_timestamp: date_string, 
//           time: currentTimeString 
//         });
        
//         await setDoc(docRef, {
//           Messages: message,
//           server: false,
//           user_id: docid,
//           shop_id: shopId,
//           User_Channel: "Web",
//           timestamp: Date.now(),
//           last_updated: serverTimestamp(),
//         }, { merge: true });
//       } 

//       // Update message count

//       // Trigger server call if needed (same logic as ChatFooter)
//       if (assigned_to === "bot@krunk.ai") {
//         setIsLoading(true); 
//         let url = "";
//         if (shopId === "null") {
//            url='https://yaan-man.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid='+docid+"&shop_id="+"YaanMan";
//           // url = 'http://127.0.0.1:8080/server?docid=' + docid + "&shop_id=" + "Krunk.ai";
//           // url='https://justwravles-demo.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid='+docid+"&shop_id="+"JustWravels";
 
//         } else if (shopId === "Krunk.ai") {
//           url = "https://krunk-demo.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid=" + docid + "&shop_id=" + "Krunk.ai";
//         } else if (shopId === "HomesterOnboardingProperties") {
//           url = 'https://homesteronboarding.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid=' + docid + "&shop_id=" + "Krunk.ai";
//         } else if (shopId === "JustWravels") {
//           url='https://modular-bot.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid='+ docid+ "&shop_id=" +shopId + "&user_message="+`${actionText} - ${productName} `;
  
//           // url = 'https://justwravles-demo.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid=' + docid + "&shop_id=" + "JustWravels";
//         } else if (shopId === "DivineHindu") {
//           url = 'https://divine-hindu-demo.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid=' + docid + "&shop_id=" + "JustWravels";
//         } else if (shopId === "smilenbeauty") {
//           url = 'https://smile-n-beauty.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid=' + docid + "&shop_id=" + "JustWravels";
//         }else if(shopId=="YaanMan"){
//           url='https://yaan-man.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid='+docid+"&shop_id="+"YaanMan";
//         }else{
//             // url='https://shopify-agent.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid='+docid+"&shop_id="+shopId;
//       url='https://modular-bot.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/server?docid='+ docid+ "&shop_id=" +shopId + "&user_message="+`${actionText} ${productName}`;
  
//         }

//         if (url) {
//           fetch(url, { method: 'GET' })
//             .then(() => {
//               setIsLoading(false); 
//             })
//             .catch((err) => console.log("Error:", err));
//         }
//       }

//     } catch (error) {
//       //console.error("Error saving action to Firestore:", error);
//     }
//   };

//   const saveAddtoCartInfo = async (actionText, productName, price) => {
//     try {
//       const urlParams = new URLSearchParams(window.location.search);
//       const currentDomain = urlParams.get("parentUrl");
//       const channel = urlParams.get("channel") || "Web";
//       const shopId = currentDomain || "null";
      
//       const uidvar = currentDomain + "uid";
//       let uid = getCookie(uidvar) || "";
      
//       const currentTimeString = getCurrentTimeString();
//       const currentTime = new Date();
//       const seconds = currentTime.getSeconds();
//       const month = String(currentTime.getMonth() + 1).padStart(2, "0");
//       const day = String(currentTime.getDate()).padStart(2, "0");
//       const year = currentTime.getFullYear();
//       const formattedHours = String(currentTime.getHours() % 12 || 12).padStart(2, "0");
//       const formattedMinutes = String(currentTime.getMinutes()).padStart(2, "0");
//       const date_string = `${month}/${day}/${year}, ${formattedHours}:${formattedMinutes}:${seconds}`;
      
//       const data_var = currentDomain + "myData";
//       const storedData = getCookie(data_var);
//       let docid = "";

//       if (!storedData) {
//         const initialData = { key: uid + Date.now().toString() };
//         setCookie(data_var, JSON.stringify(initialData));
//         docid = initialData.key;
//       } else {
//         const parsedData = JSON.parse(storedData);
//         docid = parsedData.key;
//       }

//       // Note: Not updating UI, only saving to Firestore

//       // Save to Firestore
//       const docRef = doc(db, "Messages", docid);
//       const docSnap = await getDoc(docRef);
//       let assigned_to = "bot@krunk.ai";

//       if (docSnap.exists()) {
//         const message = docSnap.data().Messages;
//         assigned_to = docSnap.data().assigned_to;
//         message.push({ 
//           user: `${actionText} ${productName}`, 
//           user_timestamp: date_string, 
//           time: currentTimeString 
//         });
        
//         await setDoc(docRef, {
//           Messages: message,
//           server: false,
//           user_id: docid,
//           shop_id: shopId,
//           User_Channel: "Web",
//           timestamp: Date.now(),
//           last_updated: serverTimestamp(),
//         }, { merge: true });
//       } 

//       const log_data={
//         "event":"Add_to_cart",
//         "params":{"item_name":productName, "price":price},
//         "shop_id":shopId,
//         "date": serverTimestamp()
//       }
//       await addDoc(collection(db, "Events"), log_data);

//     } catch (error) {
//       //console.error("Error saving action to Firestore:", error);
//     }
//   };

//   useEffect(() => {
//     const updateVisibleCards = () => {
//       if (scrollContainerRef.current) {
//         const containerWidth = scrollContainerRef.current.offsetWidth;
//         const cardsPerView = Math.floor(containerWidth / cardWidth);
//         setVisibleCards(Math.max(1, cardsPerView));
//       }
//     };

//     updateVisibleCards();
//     window.addEventListener('resize', updateVisibleCards);
//     return () => window.removeEventListener('resize', updateVisibleCards);
//   }, []);

//   const handleScroll = () => {
//     if (scrollContainerRef.current) {
//       const scrollLeft = scrollContainerRef.current.scrollLeft;
//       const newIndex = Math.round(scrollLeft / cardWidth);
//       setCurrentIndex(newIndex);
//     }
//   };

//   const scrollToIndex = (index) => {
//     if (scrollContainerRef.current) {
//       const scrollLeft = index * cardWidth;
//       scrollContainerRef.current.scrollTo({
//         left: scrollLeft,
//         behavior: 'smooth'
//       });
//       setCurrentIndex(index);
//     }
//   };

//   const totalPages = Math.ceil((options?.length || 0) / visibleCards);
//   const currentPage = Math.floor(currentIndex / visibleCards);
  
//   useEffect(() => {
//     if (selectedProducts && selectedProducts.length !== 0) {
//       setOptions(selectedProducts);
//     }
//   }, [selectedProducts]);

//   const handleProductClick = (option, event) => {
//     if (option.Website_Link) {
//       let url = option.Website_Link;
//       if (!url.startsWith('http://') && !url.startsWith('https://')) {
//         url = 'https://' + url;
//       }
//       //console.log('Opening URL:', url);
//       window.open(url, '_blank', 'noopener,noreferrer');
//     }
//   };

//   const handleAddToCart = async (option, event) => {
//     event.stopPropagation();
    
//     try {
//       // Set loading state
//       setCartStatus({ loading: true, message: 'Adding to cart...' });
      
//       const urlParams = new URLSearchParams(window.location.search);
//       const currentDomain = urlParams.get("parentUrl");
      
//       // Use PostMessage to add to parent Shopify cart
//       const variantId = option.variant_id;
      
//       if (!variantId) {
//         throw new Error('Product variant ID not found');
//       }
      
//       // Send message to parent window to add to cart
//       window.parent.postMessage({
//         type: 'ADD_TO_CART',
//         variantId: variantId,
//         quantity: 1,
//         properties: {
//           '_chatbot_added': 'true',
//           '_product_name': option.Name || '',
//           '_added_via': 'chatbot',
//           'source':'Krunk.ai'
//         }
//       }, '*');

//       const price= option.Sell_Price
//       await saveAddtoCartInfo("Add to cart", option.Name, price)
      
//     } catch (error) {
//       //console.error('Error adding to cart:', error);
//       setCartStatus({
//         loading: false,
//         message: 'Failed to add to cart: ' + error.message,
//         success: false
//       });
      
//       // Clear error message after 5 seconds
//       setTimeout(() => {
//         setCartStatus({ loading: false, message: '' });
//       }, 5000);
//     }
//   };

//   const [openMenuIndex, setOpenMenuIndex] = useState(null);

//   const toggleMenu = (index, event) => {
//     event.stopPropagation();
    
//     // Don't open menu if loading
//     if (isLoading) {
//       return;
//     }
    
//     setOpenMenuIndex(openMenuIndex === index ? null : index);
//   };

//   // Close menu when clicking outside OR when loading starts
//   useEffect(() => {
//     const handleClickOutside = () => setOpenMenuIndex(null);
//     document.addEventListener("click", handleClickOutside);
//     return () => document.removeEventListener("click", handleClickOutside);
//   }, []);

//   // Close menu when loading starts
//   useEffect(() => {
//     if (isLoading) {
//       setOpenMenuIndex(null);
//     }
//   }, [isLoading]);

//   const handleActionClick = async (menuItem, option, event) => {
//     event.stopPropagation();
    
//     // Don't allow action if loading
//     if (isLoading) {
//       return;
//     }
    
//     try {
//       // Use the menu item text as the action text
//       const actionText = menuItem;
      
//       await saveActionToFirestore(actionText, option.Name || "Unknown Product");
//     } catch (error) {
//       //console.error(`Error handling action:`, error);
//     } finally {
//       // Close the expanded actions after clicking
//       setExpandedCard(null);
//     }
//   };

//   const [visibleProductCount, setVisibleProductCount] = useState(10);

//   const loadMoreProducts = () => {
//     setVisibleProductCount(prev => Math.min(prev + 10, options.length));
//   };

//   const productsToShow = options ? options.slice(0, visibleProductCount) : [];
//   const hasMoreProducts = options && visibleProductCount < options.length;

//   const ViewMoreCard = () => (
//     <div
//       className="krunk-bg-gradient-to-br krunk-from-blue-500 krunk-to-blue-600 krunk-flex krunk-items-center krunk-cursor-pointer krunk-justify-center krunk-rounded-xl krunk-self-start krunk-shadow-lg krunk-flex-shrink-0 krunk-transition-all krunk-duration-300 hover:krunk-shadow-xl"
//       style={{
//         minWidth: '200px',
//         maxWidth: 'calc(70% - 6px)',
//         marginBottom: '8px',
//         minHeight: '280px' // Match approximate height of product cards
//       }}
//       onClick={loadMoreProducts}
//     >
//       <div className="krunk-text-center krunk-text-white krunk-p-4">
//         <div className="krunk-bg-white krunk-bg-opacity-20 krunk-rounded-full krunk-w-12 krunk-h-12 krunk-flex krunk-items-center krunk-justify-center krunk-mx-auto krunk-mb-3 krunk-transition-transform krunk-duration-300 hover:krunk-scale-110">
//           <Eye size={24} className="krunk-text-white" />
//         </div>
//         <h3 className="krunk-text-lg krunk-font-semibold krunk-mb-2">View More</h3>
//         <p className="krunk-text-blue-100 krunk-mb-3 krunk-text-sm">
//           Discover {Math.min(10, options.length - visibleProductCount)} more products
//         </p>
//         <div className="krunk-bg-white krunk-bg-opacity-20 hover:krunk-bg-opacity-30 krunk-text-white krunk-px-4 krunk-py-2 krunk-rounded-full krunk-transition-all krunk-duration-200 krunk-inline-block krunk-text-sm">
//           Load More
//         </div>
//       </div>
//     </div>
//   );

//   return (
//     <div className="krunk-mt-4">
//       <div 
//         ref={scrollContainerRef}
//         className="krunk-overflow-x-scroll krunk-overflow-y-visible krunk-no-scrollbar krunk-flex krunk-items-center krunk-gap-3 krunk-h-full"
//         onScroll={handleScroll}
//       >
//         {productsToShow && productsToShow.length !== 0 && productsToShow.map((option, i) => {
//           return (
//             <div
//               key={i}
//               className="krunk-bg-white krunk-flex krunk-items-center krunk-cursor-pointer krunk-justify-between krunk-flex-wrap krunk-rounded-xl krunk-self-start krunk-shadow-lg krunk-flex-shrink-0"
//               style={{
//                 minWidth: '200px',
//                 maxWidth: 'calc(70% - 6px)',
//                 marginBottom: '8px' // space for shadow
//               }}
//               onClick={(event) => handleProductClick(option, event)}
//             >
//               <div className="krunk-w-full krunk-flex krunk-flex-col krunk-items-start krunk-self-start">
                
//                 <div className="krunk-w-full krunk-h-[200px] krunk-rounded-t-xl krunk-overflow-hidden">
//                   <img
//                     src={option?.['Image']}
//                     className="krunk-w-full krunk-h-full krunk-object-cover krunk-transition-transform krunk-duration-200 hover:krunk-scale-125"
//                     alt={option.Name || "Product image"}
//                   />
//                 </div>
                
//                 <div className="krunk-text-xs krunk-px-2 krunk-w-full krunk-space-y-1 krunk-py-2">
//                   <h3 className="krunk-capitalize krunk-text-sm krunk-line-clamp-1 krunk-font-semibold krunk-h-4 krunk-flex krunk-items-start">
//                     {option.Name}
//                   </h3>

//                   <div>{option.Description}</div>
                  
//                   <div className="krunk-flex krunk-items-center krunk-gap-1">
//                     <span className="krunk-font-semibold">₹ {option.Sell_Price}</span>

//                     {option.MRP && (
//                       <>
//                         <span className="krunk-line-through krunk-font-semibold krunk-text-gray-400">
//                           ₹ {option.MRP}
//                         </span>
//                         <span
//                           className=" krunk-text-green-700 krunk-text-[0.65rem] krunk-font-semibold krunk-px-1 krunk-py-[1px] krunk-rounded"
//                         >
//                           {Math.round(((option.MRP - option.Sell_Price) / option.MRP) * 100)}% OFF
//                         </span>
//                       </>
//                     )}
//                   </div>

//                   {/* Action icons row */}
//                   <div className="krunk-flex krunk-gap-2 krunk-mt-2">
//                     {/* Add to cart button - always enabled */}
//                     <button 
//                       className="krunk-bg-buttonbackground krunk-text-white krunk-p-2 krunk-rounded-lg krunk-transition-colors krunk-flex krunk-items-center krunk-justify-center krunk-flex-1"
//                       onClick={(event) => handleAddToCart(option, event)}
//                     >
//                       Add to cart
//                     </button>

//                     {/* Three dots menu - only show if subMenu exists and has items */}
//                     {subMenu && subMenu.length > 0 && (
//                       <div className="krunk-relative">
//                         <button
//                           className={`krunk-p-2 krunk-rounded-lg krunk-flex krunk-items-center krunk-justify-center krunk-transition-all ${
//                             isLoading 
//                               ? 'krunk-bg-gray-100 krunk-cursor-not-allowed' 
//                               : 'hover:krunk-bg-gray-200'
//                           }`}
//                           onClick={(e) => toggleMenu(i, e)}
//                           disabled={isLoading}
//                         >
//                           <MoreVertical 
//                             size={16} 
//                             className={`krunk-transition-colors ${
//                               isLoading ? 'krunk-text-gray-300' : 'krunk-text-gray-600'
//                             }`} 
//                           />
//                         </button>

//                         {/* Drop-up menu - only show if not loading */}
//                         {openMenuIndex === i && !isLoading && (
//                           <div className="krunk-absolute krunk-bottom-full krunk-mb-2 krunk-right-0 krunk-bg-white krunk-shadow-lg krunk-rounded-lg krunk-overflow-hidden krunk-min-w-[200px] krunk-border krunk-border-gray-200">
//                             {subMenu.map((menuItem, menuIndex) => (
//                               <button
//                                 key={menuIndex}
//                                 className={`krunk-w-full krunk-text-left krunk-px-4 krunk-py-2 krunk-transition-colors ${
//                                   menuIndex !== subMenu.length - 1 ? 'krunk-border-b krunk-border-gray-200' : ''
//                                 } ${
//                                   isLoading 
//                                     ? 'krunk-text-gray-400 krunk-cursor-not-allowed krunk-bg-gray-50' 
//                                     : 'hover:krunk-bg-buttonbackground hover:krunk-text-white'
//                                 }`}
//                                 onClick={(event) => handleActionClick(menuItem, option, event)}
//                                 disabled={isLoading}
//                               >
//                                 {menuItem}
//                               </button>
//                             ))}
//                           </div>
//                         )}
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           );
//         })}
//         {hasMoreProducts && <ViewMoreCard />}
//       </div>
      
//       {(() => {
//         // Don't show dots if no products or all products fit in one view
//         if (!options || options.length <= visibleCards) {
//           return null;
//         }
        
//         // Calculate dots based on ACTUAL products that are currently shown
//         const actualProductsShown = Math.min(visibleProductCount, options.length);
//         const totalItemsShown = hasMoreProducts ? actualProductsShown + 1 : actualProductsShown; // +1 for view more card
//         const totalDotsNeeded = Math.ceil(totalItemsShown / visibleCards);
        
//         return (
//           <div className="krunk-flex krunk-justify-center krunk-items-center krunk-mt-4 krunk-gap-2 krunk-mb-4">
//             {Array.from({ length: totalDotsNeeded }, (_, index) => (
//               <button
//                 key={index}
//                 onClick={() => scrollToIndex(index * visibleCards)}
//                 className={`krunk-w-2 krunk-h-2 krunk-rounded-full krunk-transition-all krunk-duration-200 ${
//                   currentPage === index 
//                     ? 'krunk-bg-buttonbackground krunk-w-6' 
//                     : 'krunk-bg-gray-300 hover:krunk-bg-gray-400'
//                 }`}
//                 aria-label={`Go to page ${index + 1}`}
//               />
//             ))}
//           </div>
//         );
//       })()}
//     </div>
//   );
// }

// export default ProductsDisplay;